<ng-container *ngIf="{
    launches: launches$ | async,
    shouldShowTime: shouldShowTime$ | async,
    padPhotos: padPhotos$ | async } as state">
  <div class="upcoming-launch-widget" *ngIf="state.launches?.length">
    <span class="title">{{getTitle(state.launches[0])}}</span>
    <span class="time" *ngIf="state.shouldShowTime && !isMobile">
      <launch-time [missionId]="state.launches[0].link"></launch-time>
    </span>
    <span class="arrow" *ngIf="!isMobile">
      <down-arrow-svg width="9" height="9"></down-arrow-svg>
    </span>
    <div class="card-container">
      <ng-container *ngFor="let launch of state.launches; let i = index;">
        <hr class="divider" *ngIf="i == 0 && isMobile" />
        <upcoming-launch-card 
          [launch]="launch" 
          [photoUrl]="getPadPhoto(launch, state.padPhotos)" 
          *ngIf="state.padPhotos">
        </upcoming-launch-card>
        <hr class="divider" />
      </ng-container>
      <a class="footer" routerLink="/launches" tabindex="0">
        <grid-svg class="icon"></grid-svg>
        <span class="footer-text">All Upcoming Launches</span>
      </a>
    </div>
  </div>
</ng-container>